import type { ApiSistema } from "features/sistema/types";
import { newRequestMercurio } from "std/api/mercurio/newRequestMercurio";
import { isLocalHost } from "std/url";

const url = isLocalHost() ? "app.mercurioapp.com.br" : "app.mercurioapp.com.br";

export function apiSistemaPost(): Promise<ApiSistema[]> {
	return newRequestMercurio({
		url: "Sistema/Sistema",
		type: "post",
		body: { url },
		token: false,
	});
}
